import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { Location } from '../models/location';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';

@Injectable()
export class LocationService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
  

  public getAll(company_Id: number): Promise<Location[]> {
    console.log(environment.apiUrl + 'location/getall?company_Id=' + company_Id);
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<Location[]>(environment.apiUrl + 'location/getall?company_Id=' + company_Id, { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public get(location_Id: number): Promise<Location> {
    return new Promise((resolve, reject) => {
      this.http.get<Location>(environment.apiUrl + 'location/get?location_Id=' + location_Id).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public save(location: Location): Promise<Location> {

    location.company_Id = Number(location.company_Id);
    location.updated_For_PDA_Sync = new Date().toISOString().slice(0, 19).replace('T', ' ');
    console.log(location);
    

    if (location.company_Id == 0) {
      this.snotifyService.error('Please select a company');
      return;
    }

    return new Promise((resolve, reject) => {
      if (location.is_edit) {
        this.http.put<Location>(environment.apiUrl + 'location/put', location).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated location');
        }, error => {
          console.log(error);
          reject();
        });
      } else {
        this.http.post<Location>(environment.apiUrl + 'location/post', location).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added location');
        }, error => {
          console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, location_Name: string, company_Id: number, quick_Search: string): Promise<PagedData<Location>> {
    const pagedData = new PagedData<Location>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Address_1'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&location_Name=' + location_Name;
      params += '&company_Id=' + company_Id;
      params += '&quick_Search=' + quick_Search;

      this.http.get<ServerData>(environment.apiUrl + 'location/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getExcel(page: Page, location_Name: string, company_Id: number): Promise<any> {
    return new Promise((resolve, reject) => {

      let params = '?location_Name=' + location_Name;
      params += '&company_Id=' + company_Id;

      this.http.get<any>(environment.apiUrl + 'location/getExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }



  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
